import { regex } from '../../../validator/isDataType';

export const getNameRegex = () => {
 const regexPattern = regex[process.env.REACT_APP_REGION]?.name;
 return regexPattern;
};

export const initialUserDetails = {
  supplierUserMappingId: '',
  firstName: '',
  lastName: '',
  emailId: '',
  isdCode: '',
  contactNo: ''
};

export const initialSupplierAttributePayload = {
  supplierName: '',
  taxIdentifier: '',
  countryCode: '',
  taxIdentifierType: '',
  userDetails: []
};

export const initialSupplierDetailAttributes = [
  {
    attributeId: null,
    name: 'companyDetails',
    attributeType: 'COMBINE',
    className: 'supplier-company-details',
    attributes: [
      {
        attributeId: 1,
        name: 'countryCode',
        displayName: 'Country',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'SINGLE_SELECT_WITH_SEARCH',
        placeHolder: 'Select Country',
        displayOrder: 1,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            }
          }
        },
        error: '',
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        value: '',
        options: [],
        attributes: null,
        sections: []
      },
      {
        attributeId: 2,
        name: 'taxIdentifier',
        displayName: 'Tax ID',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'TEXT',
        displayOrder: 2,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            }
          }
        },
        error: '',
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        value: '',
        options: [],
        attributes: null,
        sections: []
      },
      {
        attributeId: 3,
        name: 'supplierName',
        displayName: 'Company Name',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'TEXT',
        displayOrder: 3,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            }
          }
        },
        error: '',
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        value: '',
        options: [],
        attributes: null,
        sections: [],
        disabled: true
      }
    ]
  },
  {
    attributeId: null,
    name: 'userDetails',
    attributeType: 'COMBINE',
    className: 'supplier-user-details',
    attributes: [
      {
        attributeId: 4,
        name: 'supplierUserMappingId',
        displayName: '',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'HIDDEN',
        displayOrder: 1,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            }
          }
        },
        error: '',
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        value: '',
        options: [],
        attributes: null,
        sections: []
      },
      {
        attributeId: 5,
        name: 'firstName',
        displayName: 'First Name',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'TEXT',
        displayOrder: 2,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            },
            regex: {
              pattern: getNameRegex()
            },
            length: {
              min: 1,
              max: 100
            }
          }
        },
        error: '',
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        value: '',
        options: [],
        attributes: null,
        sections: []
      },
      {
        attributeId: 6,
        name: 'lastName',
        displayName: 'Last Name',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'TEXT',
        displayOrder: 3,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            },
            regex: {
              pattern: getNameRegex()
            },
            length: {
              min: 1,
              max: 100
            }
          }
        },
        error: '',
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        value: '',
        options: [],
        attributes: null,
        sections: []
      },
      {
        attributeId: 7,
        name: 'emailId',
        displayName: 'Email',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'TEXT',
        displayOrder: 4,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            },
            regex: {
              pattern: regex.email
            }
          }
        },
        error: '',
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        value: '',
        options: [],
        attributes: null,
        sections: []
      },
      {
        attributeId: null,
        name: 'contactNo',
        displayName: 'Contact details',
        attributeType: 'COMBINE',
        className: 'supplier-contact',
        attributes: [
          {
            attributeId: 8,
            name: 'isdCode',
            value: '',
            displayName: 'Code',
            description: '',
            xpath: null,
            jsonType: null,
            attributeType: 'SINGLE_SELECT_WITH_SEARCH',
            placeHolder: 'Select code',
            displayOrder: 5,
            isVisibleForBuyer: null,
            isElementRequired: true,
            stateChangeOnEdit: false,
            isEncryptable: false,
            validation: {
              rule: {
                required: {
                  isRequired: true
                }
              }
            },
            error: '',
            nonEditableAttributeValidation: null,
            optionType: null,
            initialValue: null,
            options: [],
            attributes: null,
            sections: [],
            hide: true
          },
          {
            attributeId: 9,
            name: 'contactNo',
            displayName: 'Phone',
            description: '',
            xpath: null,
            jsonType: null,
            attributeType: 'TEXT',
            placeHolder: '',
            displayOrder: 6,
            isVisibleForBuyer: null,
            isElementRequired: true,
            stateChangeOnEdit: false,
            isEncryptable: false,
            validation: {
              rule: {
                required: {
                  isRequired: true
                },
                regex: {
                  pattern: regex.telephone
                }
              }
            },
            nonEditableAttributeValidation: null,
            optionType: null,
            initialValue: null,
            options: null,
            attributes: null,
            sections: [],
            hide: true
          }
        ],
        hide: true
      },
      {
        attributeId: null,
        name: 'addSupplier',
        displayName: '+ Add Supplier',
        description: '',
        xpath: null,
        jsonType: null,
        attributeType: 'PRIMARY_BUTTON',
        className: 'add-supplier',
        placeHolder: '',
        displayOrder: 7,
        disabled: true,
        isVisibleForBuyer: null,
        isElementRequired: true,
        stateChangeOnEdit: false,
        isEncryptable: false,
        validation: {
          rule: {
            required: {
              isRequired: true
            }
          }
        },
        nonEditableAttributeValidation: null,
        optionType: null,
        initialValue: null,
        options: null,
        attributes: null,
        sections: []
      }
    ]
  }
];

export const navigationButtons = [
  {
    attributeId: 1,
    name: 'back',
    displayName: 'Back',
    description: '',
    xpath: null,
    jsonType: null,
    attributeType: 'SECONDARY_BUTTON',
    className: 'back-btn',
    placeHolder: '',
    displayOrder: 2,
    isVisibleForBuyer: null,
    isElementRequired: true,
    stateChangeOnEdit: false,
    isEncryptable: false,
    nonEditableAttributeValidation: null,
    optionType: null,
    initialValue: null,
    options: null,
    attributes: null,
    sections: []
  },
  {
    attributeId: 2,
    name: 'submit',
    displayName: 'Submit',
    description: '',
    xpath: null,
    jsonType: null,
    attributeType: 'PRIMARY_BUTTON',
    className: 'submit-btn',
    placeHolder: '',
    displayOrder: 2,
    disabled: true,
    isVisibleForBuyer: null,
    isElementRequired: true,
    stateChangeOnEdit: false,
    isEncryptable: false,
    nonEditableAttributeValidation: null,
    optionType: null,
    initialValue: null,
    options: null,
    attributes: null,
    sections: []
  }
];

export const taxIdValidationList = {
  IN: { taxIdentifier: { pattern: /^[a-zA-Z\d\s]{15}$/, maxCharLimit: 15 } },
  DE: { taxIdentifier: { pattern: /^DE\d{9}$/, maxCharLimit: 11 } },
  NL: { taxIdentifier: { pattern: /^NL\d{9}B\d{2}$/, maxCharLimit: 14 } },
  DK: { taxIdentifier: { pattern: /^DK\d{8}$/, maxCharLimit: 10 } },
  SE: { taxIdentifier: { pattern: /^SE\d{12}$/, maxCharLimit: 14 } },
  LU: { taxIdentifier: { pattern: /^LU\d{8}$/, maxCharLimit: 10 } },
  AT: { taxIdentifier: { pattern: /^ATU\d{8}$/, maxCharLimit: 11 } },
  BE: { taxIdentifier: { pattern: /^BE\d{10}$/, maxCharLimit: 12 } },
  BG: { taxIdentifier: { pattern: /^BG\d{9,10}$/, maxCharLimit: 12 } },
  HR: { taxIdentifier: { pattern: /^HR\d{11}$/, maxCharLimit: 13 } },
  CY: { taxIdentifier: { pattern: /^CY[\dA-Z]{9}$/i, maxCharLimit: 11 } },
  CZ: { taxIdentifier: { pattern: /^CZ\d{8,10}$/, maxCharLimit: 12 } },
  EE: { taxIdentifier: { pattern: /^EE\d{9}$/, maxCharLimit:11 } },
  FI: { taxIdentifier: { pattern: /^FI\d{8}$/, maxCharLimit: 11 } },
  FR: { taxIdentifier: { pattern: /^FR[\d|A-Z]{2}\d{9}$/i, maxCharLimit: 13 } },
  GR: { taxIdentifier: { pattern: /^EL\d{9}$/, maxCharLimit: 11 } },
  HU: { taxIdentifier: { pattern: /^HU\d{8}$/, maxCharLimit: 10 } },
  IE: { taxIdentifier: { pattern: /^IE(\d[A-Z]\d{5}[A-Z]|\d{6}[A-Z]{2}|\d{7}[A-Z]|\d{7}[A-Z][AH])$/i, maxCharLimit: 11 } },
  LV: { taxIdentifier: { pattern: /^LV\d{11}$/, maxCharLimit: 13 } },
  LT: { taxIdentifier: { pattern: /^LT\d{9}(?:\d{3})?$/, maxCharLimit: 14 } },
  MT: { taxIdentifier: { pattern: /^MT\d{8}$/, maxCharLimit: 10 } },
  PL: { taxIdentifier: { pattern: /^PL\d{10}$/, maxCharLimit: 12 } },
  PT: { taxIdentifier: { pattern: /^PT\d{9}$/, maxCharLimit: 11 } },
  RO: { taxIdentifier: { pattern: /^RO\d{2,10}$/, maxCharLimit: 12 } },
  SK: { taxIdentifier: { pattern: /^SK\d{10}$/, maxCharLimit: 12 } },
  SI: { taxIdentifier: { pattern: /^SI\d{8}$/, maxCharLimit: 10 } },
  ES: { taxIdentifier: { pattern: /^ES[\d|A-Z]\d{7}[\d|A-Z]$/i, maxCharLimit: 11 } },
  GB: { taxIdentifier: { pattern: /^GB\d{9,12}$/, maxCharLimit: 14 } },
  IT: { taxIdentifier: { pattern: /^IT\d{11}$/, maxCharLimit: 13 } }
};

export const contactValidationList = {
  US: { contactNo: { pattern: /^\(?([2-9]\d{2})\)?([ -]?)([2-9]\d{2})?([ -]?)(\d{4})$/, maxCharLimit: 15 } },
  default: { contactNo: { pattern: /^(?![\s-])[0-9\s-]{5,15}(?<![\s-])$/, maxCharLimit: 15 } }
};
